module.exports = __webpack_public_path__ + "src/assets/img/02_4art_3part_gallery.51ddb9b0.jpg";